import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";                // local Storage에 저장하고 싶은 경우
import storageSession from "redux-persist/lib/storage/session"; // session Storage에 저장하고 싶은 경우
import ThunkMiddleware from "redux-thunk";
import loginReducers from "./reducers/userReducers.jsx";
import menuReducers from "./reducers/menuReducers.jsx";
import langCodeReducers from "./reducers/langCodeReducers.jsx";

// 로그인
const loginPersistConfig = {
    key: 'login',
    storage: storageSession,
    whitelist: ['userInfo', 'rememberMe'],
};

// 메뉴
const menuPersistConfig = {
    key: 'menu',
    storage: storageSession,
    whitelist: ['menuInfo'],
};

// 언어
const langCodePersistConfig = {
    key: 'langCode',
    storage,
    whitelist: ['langCodeInfo'],
};

const rootReducer = combineReducers({
    login: persistReducer(loginPersistConfig, loginReducers),
    menu: persistReducer(menuPersistConfig, menuReducers),
    langCode: persistReducer(langCodePersistConfig, langCodeReducers),
});

const middleware = [ThunkMiddleware]

export const store = configureStore({
    reducer: rootReducer,
    middleware: middleware,
});

export const persistor = persistStore(store)